import { IRuleRowModel } from '@cbridge-tools/rules-data-grid';
import { getRuleValidity, IRuleValidation, RuleWarningType } from '@cbridge-packages/rule';
import { IRulesManagementState } from '../rulesManagement.interface';

export const makeRuleRowModelAndState = <R extends IRuleValidation>(rules: R[]) => {
  const idPrefix = Date.now() - 100000;

  const initialState: IRulesManagementState = {
    errorsCount: 0,
    unusedCount: 0,
    uselessCount: 0,
  };

  type IGenericRuleRowModel = IRuleRowModel & R;
  const rows: IGenericRuleRowModel[] = rules?.map((rule, index) => {
    if (rule.errors) {
      initialState.errorsCount++;
    }
    if (rule.warnings) {
      if (RuleWarningType.Unused in rule.warnings) {
        initialState.unusedCount++;
      } else if (RuleWarningType.Useless in rule.warnings) {
        initialState.uselessCount++;
      }
    }

    return {
      ...rule,
      id: idPrefix + index,
      index,
      originalIndex: index,
      validity: getRuleValidity(rule),
    };
  });

  return {
    rows,
    initialState,
  };
};
